<template>
  <div>
    <div v-if="!showNewRuleForm">
      <rule-selector
        v-if="currentTemplates.length > 0"
        v-model="businessRuleId"
        @new-rule="showNewRuleForm = true"
      ></rule-selector>
      <form-buttons>
        <button type="button" class="btn btn-primary" @click="saveClicked">
          Save
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$emit('canceled')"
        >
          Cancel
        </button>
      </form-buttons>
    </div>
    <div v-if="showNewRuleForm">
      <h3>New Display Rule</h3>
      <rule-form
        @save="newRuleCreated"
        @cancel="showNewRuleForm = false"
      ></rule-form>
    </div>
  </div>
</template>
<script>
import currentTempates from "@/mixins/currentTemplates";
import documentModelMixin from "@/mixins/documentModel";
import RuleSelector from "@/components/business-rules/RuleSelector.vue";
import RuleForm from "@/components/business-rules/RuleForm.vue";

const newRuleCreated = function(newRule) {
  this.businessRuleId = newRule.id;
  this.showNewRuleForm = false;
};

const saveClicked = async function() {
  this.logDebug("Applying display rule.", {displayRuleId: this.businessRuleId, contentControlId: this.id});

  const model = this.documentModel;
  const contentControl = model.findContentControl(this.id);
  contentControl.displayRuleId = this.businessRuleId;

  await this.saveDocumentModel(model);
  this.logDebug("Document model saved.", model);
  this.$emit("saved");
};

export default {
  components: { RuleSelector, RuleForm },
  mixins: [documentModelMixin, currentTempates],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data: function() {
    return {
      contentControl: null,
      showNewRuleForm: false,
      businessRuleId: "",
    };
  },
  methods: {
    newRuleCreated,
    saveClicked,
  },
  emits: ["saved", "canceled"],
  mounted: function() {
    this.contentControl = this.documentModel.findContentControl(this.id);
    this.businessRuleId = this.contentControl.displayRuleId;
  },
};
</script>
